import React from "react";
import CheckoutPricePickers from "components/CheckoutPricePickers";
import { useFormikContext } from "formik";
import SectionBezel from "components/SectionBezel";
import { getIconForUID } from "components/FormerEditor/utils";
const COMPONENT_COPY = { empty: "Add a price to this checkout" };

const PricesFields = () => {
  const { values } = useFormikContext();
  const canEdit = !Boolean(values.id);
  const LockIcon = getIconForUID("lock");
  const locked = !canEdit && <LockIcon size={18} />;

  return (
    <SectionBezel header="Prices" action={locked}>
      <CheckoutPricePickers
        rootPath="data.product"
        name="prices"
        copy={COMPONENT_COPY}
        editMode={canEdit}
      />
    </SectionBezel>
  );
};

export default PricesFields;
